(ns frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-vi.controller 
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- total-investment
  [{:keys [labels total-investment]}]
  (map vector labels total-investment))

(defn- portfolio-at-fair-value
  [{:keys [labels portfolio-at-fair-value]}]
  (map vector labels portfolio-at-fair-value))

(defn ->ui-data
  [{:keys [_dynamic-data report-data] :as props}]
  {:fund-name             (:fund-name report-data)
   :reference-date        (get-in report-data [:reference-date])
   :reporting-period      (:reporting-period report-data)
   :writing-instructions  (report-ctl/rich-content
                           props
                           :partner-writing-instructions-text)

   :fund-update (report-ctl/rich-content
                 props
                 :fund-update-text)

   :general (report-ctl/with-footnote
              props
              :general-footnotes
              (:general report-data))

   :investment-strategy (report-ctl/with-footnote
                          props
                          :investment-strategy-footnotes
                          (:investment-strategy report-data))

   :key-economic-terms (report-ctl/with-footnote
                         props
                         :key-economic-terms-footnotes
                         (:key-economic-terms report-data))

   :contacts (report-ctl/with-footnote
               props
               :contacts-footnotes
               (:contacts report-data))

   :fund-progress (report-ctl/with-footnote
                    props
                    :fund-progress-footnotes
                    (:fund-progress report-data))

   :fund-progress-kpis-footnote (report-ctl/rich-content
                                  props
                                  :fund-progress-kpis-footnote-text)

   :kpis (report-ctl/with-footnote
           props
           :kpis-footnotes
           (ov-ctl/figures-v2 (:kpis report-data)))

   :chart-data-total-investment (report-ctl/with-footnote
                                  props
                                  :total-investment-footnotes
                                  (donut-chart/donut-chart-config-lifeline
                                   (total-investment
                                    (:chart-data-total-investment report-data))
                                   {:data-label-formatter
                                    chart-utils/pie-float-label-formatter-with-names-divide-m}))

   :chart-data-portfolio-at-fair-value (report-ctl/with-footnote
                                         props
                                         :portfolio-at-fair-value-footnotes
                                         (donut-chart/donut-chart-config-lifeline
                                          (portfolio-at-fair-value
                                           (:chart-data-portfolio-at-fair-value report-data))
                                          {:data-label-formatter
                                           chart-utils/pie-float-label-formatter-with-names-divide-m}))

   :current-portfolio (report-ctl/with-footnote
                        props
                        :current-portfolio-footnotes
                        (:current-portfolio report-data))

   :exited-portfolio (report-ctl/with-footnote
                       props
                       :exited-portfolio-footnotes
                       (:exited-portfolio report-data))

   :investment-summary (report-ctl/with-footnote
                         props
                         :investment-summary-footnotes
                         (:investment-summary report-data))

   :fund-cash-flows (report-ctl/with-footnote
                      props
                      :fund-cash-flows-footnotes
                      (:fund-cash-flows report-data))

   :fund-assets (report-ctl/with-footnote
                  props
                  :fund-assets-footnotes
                  (:fund-assets report-data))

   :carried-interest (report-ctl/with-footnote
                       props
                       :carried-interest-footnotes
                       (:carried-interest report-data)) 

   :management-fees (report-ctl/with-footnote
                      props
                      :management-fees-footnotes
                      (:management-fees report-data))

   :fund-expenses-and-costs (report-ctl/with-footnote
                              props
                              :fund-expenses-and-costs-footnotes
                              (:fund-expenses-and-costs report-data))

   :fund-operating-expenses (report-ctl/with-footnote
                              props
                              :fund-operating-expenses-footnotes
                              (:fund-operating-expenses report-data))
   
   :other-expenses (report-ctl/with-footnote
                     props
                     :other-expenses-footnotes
                     (:other-expenses report-data))})
